export default __webpack_public_path__ + "static/sorties-55aba1652002aa8a829bec26ed67fd43.jpg";